'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bluebird = require('bluebird');

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HtmlUtils = require('../../../HtmlUtils');

var HtmlUtils = _interopRequireWildcard(_HtmlUtils);

var _MessageDiffUtils = require('../../../utils/MessageDiffUtils');

var _DateUtils = require('../../../DateUtils');

var _matrixJsSdk = require('matrix-js-sdk');

var _pillify = require('../../../utils/pillify');

var _languageHandler = require('../../../languageHandler');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

function getReplacedContent(event) {
    var originalContent = event.getOriginalContent();
    return originalContent["m.new_content"] || originalContent;
}

var EditHistoryMessage = function (_React$PureComponent) {
    (0, _inherits3.default)(EditHistoryMessage, _React$PureComponent);

    function EditHistoryMessage(props) {
        (0, _classCallCheck3.default)(this, EditHistoryMessage);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EditHistoryMessage.__proto__ || (0, _getPrototypeOf2.default)(EditHistoryMessage)).call(this, props));

        _initialiseProps.call(_this);

        var cli = _MatrixClientPeg2.default.get();
        var userId = cli.credentials.userId;

        var event = _this.props.mxEvent;
        var room = cli.getRoom(event.getRoomId());
        if (event.localRedactionEvent()) {
            event.localRedactionEvent().on("status", _this._onAssociatedStatusChanged);
        }
        var canRedact = room.currentState.maySendRedactionForEvent(event, userId);
        _this.state = { canRedact: canRedact, sendStatus: event.getAssociatedStatus() };
        return _this;
    }

    (0, _createClass3.default)(EditHistoryMessage, [{
        key: 'pillifyLinks',
        value: function pillifyLinks() {
            // not present for redacted events
            if (this.refs.content) {
                (0, _pillify.pillifyLinks)(this.refs.content.children, this.props.mxEvent);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.pillifyLinks();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var event = this.props.mxEvent;
            if (event.localRedactionEvent()) {
                event.localRedactionEvent().off("status", this._onAssociatedStatusChanged);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.pillifyLinks();
        }
    }, {
        key: '_renderActionBar',
        value: function _renderActionBar() {
            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
            // hide the button when already redacted
            var redactButton = void 0;
            if (!this.props.mxEvent.isRedacted() && !this.props.isBaseEvent) {
                redactButton = _react2.default.createElement(
                    AccessibleButton,
                    { onClick: this._onRedactClick, disabled: !this.state.canRedact },
                    (0, _languageHandler._t)("Remove")
                );
            }
            var viewSourceButton = _react2.default.createElement(
                AccessibleButton,
                { onClick: this._onViewSourceClick },
                (0, _languageHandler._t)("View Source")
            );
            // disabled remove button when not allowed
            return _react2.default.createElement(
                'div',
                { className: 'mx_MessageActionBar' },
                redactButton,
                viewSourceButton
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var mxEvent = this.props.mxEvent;

            var content = getReplacedContent(mxEvent);
            var contentContainer = void 0;
            if (mxEvent.isRedacted()) {
                var UnknownBody = _index2.default.getComponent('messages.UnknownBody');
                contentContainer = _react2.default.createElement(UnknownBody, { mxEvent: this.props.mxEvent });
            } else {
                var contentElements = void 0;
                if (this.props.previousEdit) {
                    contentElements = (0, _MessageDiffUtils.editBodyDiffToHtml)(getReplacedContent(this.props.previousEdit), content);
                } else {
                    contentElements = HtmlUtils.bodyToHtml(content, null, { stripReplyFallback: true });
                }
                if (mxEvent.getContent().msgtype === "m.emote") {
                    var name = mxEvent.sender ? mxEvent.sender.name : mxEvent.getSender();
                    contentContainer = _react2.default.createElement(
                        'div',
                        { className: 'mx_EventTile_content', ref: 'content' },
                        '*\xA0',
                        _react2.default.createElement(
                            'span',
                            { className: 'mx_MEmoteBody_sender' },
                            name
                        ),
                        '\xA0',
                        contentElements
                    );
                } else {
                    contentContainer = _react2.default.createElement(
                        'div',
                        { className: 'mx_EventTile_content', ref: 'content' },
                        contentElements
                    );
                }
            }

            var timestamp = (0, _DateUtils.formatTime)(new Date(mxEvent.getTs()), this.props.isTwelveHour);
            var isSending = ['sending', 'queued', 'encrypting'].indexOf(this.state.sendStatus) !== -1;
            var classes = (0, _classnames2.default)({
                "mx_EventTile": true,
                "mx_EventTile_redacted": mxEvent.isRedacted(),
                "mx_EventTile_sending": isSending,
                "mx_EventTile_notSent": this.state.sendStatus === 'not_sent'
            });
            return _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    'div',
                    { className: classes },
                    _react2.default.createElement(
                        'div',
                        { className: 'mx_EventTile_line' },
                        _react2.default.createElement(
                            'span',
                            { className: 'mx_MessageTimestamp' },
                            timestamp
                        ),
                        contentContainer,
                        this._renderActionBar()
                    )
                )
            );
        }
    }]);
    return EditHistoryMessage;
}(_react2.default.PureComponent);

EditHistoryMessage.propTypes = {
    // the message event being edited
    mxEvent: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixEvent).isRequired,
    previousEdit: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixEvent),
    isBaseEvent: _propTypes2.default.bool
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this._onAssociatedStatusChanged = function () {
        _this2.setState({ sendStatus: _this2.props.mxEvent.getAssociatedStatus() });
    };

    this._onRedactClick = (0, _bluebird.method)(function () {
        var event = _this2.props.mxEvent;
        var cli = _MatrixClientPeg2.default.get();
        var ConfirmAndWaitRedactDialog = _index2.default.getComponent("dialogs.ConfirmAndWaitRedactDialog");

        _Modal2.default.createTrackedDialog('Confirm Redact Dialog', 'Edit history', ConfirmAndWaitRedactDialog, {
            redact: function redact() {
                return cli.redactEvent(event.getRoomId(), event.getId());
            }
        }, 'mx_Dialog_confirmredact');
    });

    this._onViewSourceClick = function () {
        var ViewSource = _index2.default.getComponent('structures.ViewSource');
        _Modal2.default.createTrackedDialog('View Event Source', 'Edit history', ViewSource, {
            roomId: _this2.props.mxEvent.getRoomId(),
            eventId: _this2.props.mxEvent.getId(),
            content: _this2.props.mxEvent.event
        }, 'mx_Dialog_viewsource');
    };
};

exports.default = EditHistoryMessage;
module.exports = exports['default'];
//# sourceMappingURL=EditHistoryMessage.js.map